import React from 'react';

import { LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';
import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { UnitedState } from './types';
import {
  mapRawStatesResponseItemToAutocompleteOption,
  mapStatesQueryResponseToRawArray,
  useStatesQuery,
} from './utils';

import { FormInputProps } from '../../components/types';

type StatesSingleAutocompleteProps = {
  name: string;
  label: string;
  inputProps?: FormInputProps;
  disabled?: boolean;
};

export const StatesSingleAutocomplete: React.FC<StatesSingleAutocompleteProps> = ({
  name,
  label,
  inputProps,
  disabled,
}) => {
  const { isEditable } = useCanEditFormFieldsContext();
  const isDisabled = disabled || !isEditable;

  return (
    <LazyAutocompleteFieldNotMultiple<UnitedState, UnitedState[]>
      name={name}
      label={label}
      disabled={isDisabled}
      useLazyQuery={useStatesQuery}
      mapQueryResponseToRawArray={mapStatesQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawStatesResponseItemToAutocompleteOption}
      inputProps={{ margin: 'normal', ...inputProps }}
    />
  );
};
